<template>
  <div class="liquid-crystal-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>偏振光 + 旋光效应</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Light Source -->
          <line x1="20" y1="120" x2="60" y2="120" stroke="#ffd700" stroke-width="8" opacity="0.3" />
          
          <!-- Polarizer 1 (Fixed) -->
          <rect x="60" y="60" width="10" height="120" fill="#333" />
          <line x1="65" y1="70" x2="65" y2="170" stroke="#fff" stroke-dasharray="2,2" />
          <text x="50" y="50" fill="#888" font-size="8">偏振片 1</text>

          <!-- Liquid Crystal Layer -->
          <g transform="translate(100, 60)">
             <rect x="0" y="0" width="120" height="120" fill="rgba(0, 210, 255, 0.05)" stroke="rgba(255,255,255,0.1)" />
             <!-- LC Molecules (Rod-like) -->
             <g v-for="r in 4" :key="'r'+r">
                <ellipse v-for="c in 5" :key="'c'+c" :cx="c*20" :cy="r*24" rx="2" ry="8" fill="#00d2ff" :transform="`rotate(${moleculeAngle}, ${c*20}, ${r*24})`" />
             </g>
          </g>

          <!-- Polarizer 2 (Analyzer) -->
          <rect x="250" y="60" width="10" height="120" fill="#333" />
          <line x1="255" y1="70" x2="255" y2="170" stroke="#fff" stroke-dasharray="2,0" transform="rotate(90, 255, 120)" />
          <text x="240" y="50" fill="#888" font-size="8">偏振片 2 (垂直)</text>

          <!-- Output Intensity -->
          <rect x="300" y="80" width="60" height="80" :fill="outputColor" stroke="#555" />
          <text x="305" y="175" fill="#888" font-size="8">输出亮度</text>

          <!-- Light Ray -->
          <line x1="65" y1="120" x2="255" y2="120" stroke="#ffd700" :stroke-width="intensity" opacity="0.6" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>电场控制分子排列</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>施加电压 (电场 E)</label>
             <el-slider v-model="voltage" :min="0" :max="100" size="mini"></el-slider>
          </div>
          <div class="row">
             <div class="status-tag" :style="{ backgroundColor: voltage > 50 ? '#ff475722' : '#2ed57322', color: voltage > 50 ? '#ff4757' : '#2ed573' }">
                {{ voltage > 50 ? '分子定向排列 (遮光)' : '分子旋光排列 (透光)' }}
             </div>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>液晶是一种介于液体和晶体之间的态，具有**旋光性**。在不加电场时，分子的扭曲排列会旋转光的偏振方向，使其穿过第二个偏振片；通电后，分子定向排列失去旋光能力，光被遮挡。这就是 LCD 显示明暗的根本原理。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiquidCrystalViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      voltage: 0
    }
  },
  computed: {
    moleculeAngle() {
       // From 90 (twisted) to 0 (aligned with field)
       return 90 - (this.voltage * 0.9);
    },
    intensity() {
       // Maximum light when angle is near 90 (旋光 matching second polarizer)
       return Math.sin(this.moleculeAngle * Math.PI / 180) * 4;
    },
    outputColor() {
       let alpha = Math.sin(this.moleculeAngle * Math.PI / 180);
       return `rgba(255, 215, 0, ${alpha})`;
    }
  }
}
</script>

<style scoped lang="scss">
.liquid-crystal-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.status-tag { padding: 4px 12px; border-radius: 4px; font-size: 0.75rem; border: 1px solid currentColor; }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 111, 253, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
